import { render, staticRenderFns } from "./albumDesc.vue?vue&type=template&id=414c3a8a&scoped=true&"
import script from "./albumDesc.vue?vue&type=script&lang=ts&"
export * from "./albumDesc.vue?vue&type=script&lang=ts&"
import style0 from "./albumDesc.vue?vue&type=style&index=0&id=414c3a8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414c3a8a",
  null
  
)

export default component.exports